import React, { useState, useEffect } from "react";
import axios from "axios";
import api from "../../common/api";
import {
  Button,
  InputAdornment,
  MenuItem,
  TextField,
  Typography
} from "@material-ui/core";
import InfoAutoFeatures from "./InfoAutoFeatures";
import SearchIcon from "@material-ui/icons/Search";
import { set } from "react-ga";

const InfoAuto = ({ variation, version, onCodiaSelected }) => {
  const [infoautoVersions, setInfoautoVersions] = useState([]);
  const [searching, setSearching] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [queryString, setQueryString] = useState("");
  const [openTechnicalSheet, setOpenTechnicalSheet] = useState(false);
  const searchCodia = () => {
    setSearching(true);
    const token = localStorage.getItem("userToken");
    axios
      .get(api.infoauto().search(queryString), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setInfoautoVersions(res.data);
        setSearching(false);
      });
  };
  const onChange = e => {
    const codia = e.target.value;
    onCodiaSelected(codia);
  };

  useEffect(() => {
    if (version.id) {
      setQueryString(variation.dnrpa_description);
    }
  }, []);

  return (
    <div className="row">
      <div className="col-12 py-2">
        <Typography variant="h6">InfoAuto</Typography>
      </div>
      <div className="col-12">
        {version.infoauto_description && (
          <TextField
            id="infoauto_description"
            value={
              version.infoauto_description ? version.infoauto_description : ""
            }
            disabled={true}
            type="text"
            name="infoauto_description"
            margin="normal"
            className="m-0 p-0 mr-4 col-md-4"
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">Descripcion</Typography>
                </InputAdornment>
              )
            }}
          />
        )}
        <TextField
          id="codia"
          value={version.infoauto_codia ? version.infoauto_codia : "Sin valor"}
          disabled={true}
          type="text"
          name="codia"
          margin="normal"
          className="m-0 p-0 mr-4 col-md-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">CODIA</Typography>
              </InputAdornment>
            )
          }}
        />
        {onCodiaSelected && !showSearch && (
          <Button
            variant="contained"
            color="default"
            size="small"
            style={{ fontSize: "0.75rem" }}
            onClick={() => setShowSearch(true)}
          >
            Cambiar CODIA
          </Button>
        )}

        {onCodiaSelected && showSearch && (
          <>
            <TextField
              id="queryString"
              value={queryString}
              type="text"
              name="queryString"
              margin="normal"
              placeholder="Escriba para buscar en infoauto"
              className="m-0 p-0 mr-4 col-md-4"
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => setQueryString(e.target.value)}
              inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">
                      <Button
                        variant="contained"
                        disabled={searching || !queryString}
                        color="default"
                        size="small"
                        style={{
                          fontSize: "0.75rem",
                          marginBottom: "10px",
                          marginLeft: "20px"
                        }}
                        onClick={() => {
                          searchCodia();
                          setOpenTechnicalSheet(false);
                        }}
                      >
                        Buscar
                        <SearchIcon style={{ width: 20 }} />
                      </Button>
                    </Typography>
                  </InputAdornment>
                )
              }}
            />
          </>
        )}
        {version.info_auto_features && !showSearch && (
          <>
            <Typography
              variant="button"
              className="ml-4"
              onClick={() => setOpenTechnicalSheet(!openTechnicalSheet)}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                display: "inline-block"
              }}
            >
              {openTechnicalSheet ? "Ocultar" : "Ver"} Ficha Técnica{" "}
            </Typography>
            {openTechnicalSheet && (
              <InfoAutoFeatures features={version.info_auto_features} />
            )}
          </>
        )}
      </div>
      <div className="col-12 mt-2">
        {infoautoVersions && infoautoVersions.length > 0 && (
          <TextField
            id="infoauto_versions"
            name="infoauto_versions"
            select
            className="mt-0 col-md-5"
            margin="normal"
            InputLabelProps={{
              shrink: true
            }}
            onChange={onChange}
            value={version.infoauto_codia}
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption">
                    Seleccione una versión
                  </Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          >
            {infoautoVersions.map(option => (
              <MenuItem
                key={option.codia}
                value={option.codia}
                style={{ fontSize: "0.75rem" }}
              >
                {option.brand.name} {option.model} ({option.codia}) - (
                {option.prices_from} - {option.prices_to})
              </MenuItem>
            ))}
          </TextField>
        )}
      </div>
    </div>
  );
};

export default InfoAuto;
